import { memberId } from '@trello/session-cookie';
import { PersistentSharedState } from '@trello/shared-state';

import { isWorkspaceNavigationEnabled } from './isWorkspaceNavigationEnabled';

interface WorkspaceNavigationState {
  expanded: boolean;
}

export const workspaceNavigationState = new PersistentSharedState<WorkspaceNavigationState>(
  { expanded: isWorkspaceNavigationEnabled() && false },
  `workspaceNavigation-${memberId ?? 'anonymous'}`,
);
